var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar12({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.8377 49.8007C99.8377 77.2321 77.6002 99.4696 50.1689 99.4696C22.7375 99.4696 0.5 77.2321 0.5 49.8007C0.5 22.3693 22.7375 0.131836 50.1689 0.131836C77.6002 0.131836 99.8377 22.3693 99.8377 49.8007Z",
    fill: "#459F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3494 25.6306L59.2793 33.451L49.3721 33.1371L49.2776 33.1335L49.2293 33.2153L41.5391 46.1927L41.5243 46.2179L41.519 46.2464L38.9741 60.5581L30.3648 62.2263L25.3573 30.9053L58.3494 25.6306Z",
    fill: "#E03167",
    stroke: "#5E2143",
    strokeWidth: 0.320444
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3928 35.2537L27.0376 33.0335L28.1605 32.0805L34.0934 30.952L38.7354 56.4357L36.8128 56.9164L38.0945 60.281L30.8553 62.368L26.3928 35.2537Z",
    fill: "#ECD8D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2119 59.0185L59.7186 61.1665L59.7613 61.3466L59.9335 61.2794L63.4751 59.8974L65.7283 68.205L36.0225 72.8614L33.6498 72.0719L32.646 70.784L31.4012 63.904L59.2119 59.0185Z",
    fill: "#841A44",
    stroke: "#5E2143",
    strokeWidth: 0.320444
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3828 69.3649L24.5452 36.2614C24.2872 34.7981 24.621 33.2923 25.4732 32.0751C26.3254 30.858 27.6263 30.0292 29.0895 29.7712L56.6758 24.9065C57.2611 24.8033 57.8634 24.9368 58.3503 25.2777C58.8371 25.6186 59.1686 26.1389 59.2719 26.7242L60.8352 34.4928M30.3828 69.3649C30.6409 70.8282 31.4696 72.129 32.6868 72.9812C33.9039 73.8334 35.4098 74.1673 36.873 73.9092L64.4593 69.0445C65.0446 68.9413 65.5649 68.6098 65.9058 68.1229C66.2467 67.6361 66.3802 67.0337 66.277 66.4484L65.4816 61.7305M30.3828 69.3649C30.1248 67.9016 30.4586 66.3958 31.3108 65.1786C32.1631 63.9615 33.4639 63.1328 34.9272 62.8747L42.8903 61.4101",
    stroke: "#5E2143",
    strokeWidth: 4.29395,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3125 27.5664L37.732 26.0761L40.505 41.742L35.6275 38.9101L32.0855 43.2323L29.3125 27.5664Z",
    fill: "#FB3D09"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4531 27.3536L36.7078 26.2465L38.9661 39.0045L35.2974 36.6446L32.7114 40.1116L30.4531 27.3536Z",
    fill: "#FA620B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6504 33.8555L83.3468 43.7987L76.5027 69.0574L70.357 67.9074L65.3901 60.5372L53.2132 57.1725L47.7657 60.5372L39.8063 59.1141L46.6504 33.8555Z",
    fill: "#C98986"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6523 41.2559L81.0919 44.3534L81.0919 59.4143L76.7602 66.8618L74.6523 41.2559Z",
    fill: "#F5E3F7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0039 46.0604L54.0583 47.1849L58.1127 48.3094M55.1714 43.1716L52.9451 51.1982M67.6921 53.1274L67.7124 53.133M74.8869 50.8009L74.9071 50.8065M76.2911 40.3853L54.7217 34.4029C52.7152 33.8468 50.5759 34.0469 48.7174 34.9644C46.8588 35.8818 45.413 37.4515 44.6594 39.3701L44.5404 39.6655C44.0011 40.9724 39.9716 50.7463 39.1123 53.8446C38.6694 55.4412 38.8855 57.1501 39.7129 58.5954C40.5403 60.0407 41.9113 61.104 43.5242 61.5513C45.5514 62.1136 46.8433 61.3914 48.1352 60.6692L51.7886 58.6268C52.7575 58.085 53.9059 57.948 54.9812 58.246L63.7874 60.6884C64.8625 60.9869 65.7763 61.6958 66.3277 62.6593L68.4072 66.2918C69.1425 67.5762 69.8778 68.8607 71.9051 69.4229C73.518 69.8703 75.2408 69.6651 76.6944 68.8525C78.1481 68.0398 79.2135 66.6864 79.6563 65.0898C80.5162 61.9895 82.0963 51.5384 82.3072 50.1404C82.3215 50.0363 82.338 49.9321 82.3568 49.8278C82.6996 47.795 82.2692 45.7044 81.1489 43.9602C80.0285 42.2161 78.2977 40.9424 76.2911 40.3853Z",
    stroke: "#8B565C",
    strokeWidth: 4.57778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar12);
export default __webpack_public_path__ + "static/media/avatar12.54584bb9f9b3f7327942e62c56ab95c1.svg";
export { ForwardRef as ReactComponent };